import { Box, font, themedColor } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { Section, SectionParagraph, SectionTitle as Title, adjustContentVisibility } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import { BrandsImage, PizzaArea } from './components';

const Subtitle = styled(SectionParagraph)`
  white-space: normal;
`;

const Disclaimer = styled.p`
  ${font('main', { fontSize: '1.6rem', lineHeight: '28px' })};
  color: ${themedColor('metal')};
`;

const StyledSection = styled(Section)`
  ${adjustContentVisibility}
`;

export interface BrandsImages {
  readonly desktop: StaticImageData;
  readonly mobile: StaticImageData;
}

export type PizzaMobileImages = [
  { readonly image: StaticImageData | string; readonly text: string },
  { readonly image: StaticImageData | string; readonly text: string },
  { readonly image: StaticImageData | string; readonly text: string },
];

export interface HowItWorksProps extends DefaultSectionProps {
  readonly title: string;
  readonly subtitle: string;
  readonly disclaimer: string;
  readonly pizzaDesktop: string;
  readonly pizzaBreakPoint?: number;
  readonly pizzaMobile: PizzaMobileImages;
  readonly brandsImage?: BrandsImages;
  readonly showBrandsImage?: boolean;
}

export const HowItWorks: React.FC<HowItWorksProps> = ({
  title,
  subtitle,
  disclaimer,
  pizzaDesktop,
  pizzaMobile,
  brandsImage,
  pizzaBreakPoint,
  showBrandsImage = false,
  ...sectionProps
}) => {
  return (
    <StyledSection {...sectionProps} py={[40, 70]} px="20px">
      <Title data-edit-for="title" tabIndex={0}>
        {parse(title)}
      </Title>
      <Box maxWidth={'800px'} mt={'10px'}>
        <Subtitle data-edit-for="subtitle" id="how-it-works-subtitle">
          {parse(subtitle)}
        </Subtitle>
      </Box>
      <PizzaArea
        pizzaBreakPoint={pizzaBreakPoint}
        pizzaDesktop={pizzaDesktop}
        pizzaMobile={pizzaMobile}
        showBrandsImage={showBrandsImage}
      />
      <BrandsImage brandsImage={brandsImage} showBrandsImage={showBrandsImage} />

      <Box maxWidth="1100px" mt={['0px', '40px']} textAlign="center" width="100%">
        <Disclaimer id="how-it-works-disclaimer" data-edit-for="disclaimer">
          {parse(disclaimer)}
        </Disclaimer>
      </Box>
    </StyledSection>
  );
};
